export default {
  dashboard: 'Dashboard',
  IdcList: '数据中心',
  ContanierMonitor: '容器监控',
  CabinetList: '机柜列表',
  NodeDashboard: 'Kubernetes',
  DeployDashboard: 'CI/CD',
  home: '首页',
  components: '组件',
  count_to_page: '数字渐变',
  tables_page: '多功能表格',
  split_pane_page: '分割窗口',
  markdown_page: 'Markdown编辑器',
  editor_page: '富文本编辑器',
  icons_page: '自定义图标',
  img_cropper_page: '图片编辑器',
  update: '上传数据',
  join_page: 'QQ群',
  doc: '文档',
  update_table_page: '上传CSV文件',
  update_paste_page: '粘贴表格数据',
  multilevel: '多级菜单',
  directive_page: '指令',
  level_1: 'level-1',
  level_2: 'level-2',
  level_2_1: 'level-2-1',
  excel: 'Excel',
  'upload-excel': '上传excel',
  'export-excel': '导出excel',
  tools_methods_page: '工具函数',
  drag_list_page: '拖拽列表',
  i18n_page: '多语言',
  modalTitle: '模态框题目',
  content: '这是模态框内容',
  buttonText: '显示模态框',
  'i18n-tip': '注：仅此页做了多语言，其他页面没有在多语言包中添加语言内容',
  error_store_page: '错误收集',
  error_logger_page: '错误日志',
  user_manage: '用户管理',
  account_manage: '账号管理',
  group_manage: '用户组管理',
  role_manage: '角色管理',
  'menu-manage': '菜单管理',
  monitor: '监控',
  monitor_template: '监控模板',
  monitor_query: '监控查询',
  alarm_metric: '告警策略',
  settings: '配置中心',
  interface: '界面配置',
  change_password: '修改密码',
  flow: '持续交付',
  ProjectFlowList: '创建应用',
  ProjectFlowDetail: '项目工作流详情',
  GitFlowList: 'Git发布流水线',
  GitFlowDetail: 'Git工作流详情',
  SvnFlowList: 'Svn发布流水线',
  SvnFlowDetail: 'Svn工作流详情',
  project: '应用管理',
  ProjectList: '应用列表',
  ProjectDetail: '应用详情',
  ProjectEdit: '应用编辑',
  ops_center: '操作中心',
  certificate_manage: '凭证管理',
  server_manage: '主机管理',
  script_manage: '脚本管理',
  cron_manage: '计划任务管理',
  server_detail: '主机详情',
  support_manage: '服务商管理',
  springboard: '堡垒机',
  SpringBoardMain: '安全审计',
  WebTerminal: '远程连接',
  cron_detail: '计划任务详情',
  database: '数据库管理',
  InstanceList: '实例列表',
  CategoryList: '类型管理',
  ParamList: '参数管理',
  InstanceDetail: '实例详情',
  alarm_logs: '告警记录',
  cmdb: '资产管理',
  fixed_asset: '固定资产',
  FileHistoryList: '文件上传',
  logs: '日志平台',
  LogQuery: '日志搜索',
  cloud: '容器云',
  ImageList: '容器镜像',
  NodeList: '容器节点',
  PodList: '容器管理',
  VolumesList: '持久化存储卷',
  DeploymentList: '容器部署',
  MySQL: 'MySQL',
  SQLSERVER: 'SQLSERVER',
  MongoDB: 'MongoDB',
  mysqlInstanceInfo: 'MySQL基本信息',
  mysqlInstanceUser: 'MySQL账户管理',
  mysqlInstanceParam: 'MySQL参数设置',
  mysqlInstanceBackup: 'MySQL备份列表',
  mysqlInstanceLog: 'MySQL实例日志',
  mysqlInstanceOpsLog: 'MySQL操作日志',
  mysqlParamList: 'MySQL参数列表',
  mysqlInstanceSQL: 'MySQL执行SQL',
  mysqlInstanceDatabase: 'MySQL数据库管理',
  sqlserverInstanceInfo: 'SQLSERVER基本信息',
  sqlserverInstanceUser: 'SQLSERVER账户管理',
  sqlserverInstanceParam: 'SQLSERVER参数设置',
  sqlserverInstanceBackup: 'SQLSERVER备份列表',
  sqlserverInstanceLog: 'SQLSERVER实例日志',
  sqlserverInstanceOpsLog: 'SQLSERVER操作日志',
  sqlserverInstanceDatabase: 'SQLSERVER数据库管理',
  mongodbInstanceInfo: 'MongoDB基本信息',
  mongodbInstanceUser: 'MongoDB账户管理',
  mongodbInstanceParam: 'MongoDB参数设置',
  mongodbInstanceBackup: 'MongoDB备份列表',
  mongodbInstanceLog: 'MongoDB实例日志',
  mongodbInstanceOpsLog: 'MongoDB操作日志',
  mongodbInstanceDatabase: 'MongoDB数据库管理',
  mongodbInstanceNode: 'MongoDB节点列表',
  MySQLMigrate: '克隆数据列表',
  databaseDashboard: '数据库监控面板',
  privateCloud: '私有云',
  compute: '计算',
  server: '实例',
  image: '镜像',
  keyPairs: '密钥对',
  storage: '存储',
  volumes: '卷',
  backups: '备份',
  snapshots: '快照',
  net: '网络',
  topology: '拓扑图',
  network: '网络',
  route: '路由',
  securityGroups: '安全组',
  floatingIps: '浮动IP',
  image_detail: '镜像详情',
  flavor: '实例类型',
  heart_config: '心跳设置',
  AgentServerMain: 'Agent管理'
}
